import { render, staticRenderFns } from "./Si.vue?vue&type=template&id=39c1a6e6&scoped=true&"
import script from "./Si.vue?vue&type=script&lang=js&"
export * from "./Si.vue?vue&type=script&lang=js&"
import style0 from "./Si.vue?vue&type=style&index=0&id=39c1a6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1a6e6",
  null
  
)

export default component.exports